import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { localStorageStore, useTranslate } from 'react-admin';
import axios from '../../plugins/axios';
import { Typography, Box, Tabs, Tab, Breadcrumbs } from '@mui/material';
import CustomButton from '../shared/CustomButton';
import MoviePackageEdit from './MoviePackageEdit';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function BasicTabs() {
  const [value, setValue] = useState(0);
  const store = localStorageStore();
  const [tabValues, setTabValues] = useState();

  const id = store.getItem('mediaItemId');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    async function fetchTranslationData() {
      const response = await axios(`/media-item/${id}/translatable-ids`, {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
          'Content-Type': 'application/json',
        },
      });
      return response;
    }

    if (!tabValues) {
      fetchTranslationData().then((response) => {
        setTabValues(response.data);
      });
    }
  }, []);

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mx: 3 }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label='basic tabs example'
        >
          {tabValues &&
            tabValues.map((item) => {
              return (
                <Tab
                  key={item.mediaItemId}
                  label={item.languageName}
                  sx={{ paddingLeft: 0 }}
                />
              );
            })}
        </Tabs>
      </Box>
      {tabValues &&
        tabValues.map((item, index) => {
          return (
            <TabPanel
              key={`${item.mediaItemId} + ${index}}`}
              value={value}
              index={index}
              className='customer-edit-panel'
            >
              <MoviePackageEdit
                langId={item.languageId}
                id={item.mediaItemId}
              />
            </TabPanel>
          );
        })}
    </Box>
  );
}

const EditPackage = () => {
  const navigate = useNavigate();
  const translate = useTranslate();

  return (
    <>
      <div style={{ position: 'relative' }}>
        <Breadcrumbs aria-label='breadcrumb' sx={{ pl: 3, mb: 1 }}>
          <CustomButton
            variant='link'
            title={translate('resources.content.content')}
            handleClick={() => navigate('/content/media-catalog')}
          />
          <CustomButton
            variant='link'
            title={translate('resources.content.edit_movie_package')}
          />
        </Breadcrumbs>
        <Typography variant='h5' sx={{ paddingLeft: 3, mb: 3 }}>
          {translate('resources.content.edit_movie_package')}
        </Typography>
      </div>
      <BasicTabs />
    </>
  );
};

export default EditPackage;
